import React, { Component } from 'react'
import { connect } from 'react-redux'

import * as R from 'ramda'
import moment from 'moment'

import TextField from 'material-ui/TextField'
import {Card, CardActions, CardHeader, CardMedia, CardTitle, CardText} from 'material-ui/Card'
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import DatePicker from 'material-ui/DatePicker'

import ValidTextField from 'components/validTextField'

import dataActions from 'actions/dataActions'

import { doc, dirtyRead } from 'selectors/common'
import { propertyLoan } from 'selectors/property'
import Section from 'components/Section'
import { getTimezoneDate } from 'utils/date'
import {getMonth} from 'utils/date'

let select = dirtyRead(
	(state, props) => ({
		property: doc(state, props.propertyID)
	  , loan: propertyLoan(state, props)
	})
)

export class Schedules extends Component{
	render(){
		let { props } = this
		let propertyID = props.propertyID
		return(
			<Section id="property/schedule" title="Mortgage">
				<div style={{width: "auto", marginTop: "-20px"}}>

					<ValidTextField
						value={props.property.downPayment}
						key={'props.property.downPayment'+props.property.downPayment}
						symbol="$"
						style={{
							width: "48%",
							marginBottom: "-15px",
							float: "left"
						}}
						floatingLabelText = "Downpayment"
						onBlur={(value) =>{
							let valueInt = value.replace(/\,/ig, '');
							valueInt = valueInt.replace(/\$/ig, '');
							valueInt = valueInt.replace(/\%/ig, '');
							props.STAGE({
								_id: propertyID
								, downPayment: +valueInt
							})
						}}
					/>
					<ValidTextField
						value={props.property.mortgageLoan}
						key={'props.property.mortgageLoan'+props.property.mortgageLoan}
						symbol="$"
						style={{
							width: "48%",
							marginBottom: "-15px",
							float: "right"
						}}
						floatingLabelText = "Loan"
						onBlur={(value) =>{
							let valueInt = value.replace(/\,/ig, '');
							valueInt = valueInt.replace(/\$/ig, '');
							valueInt = valueInt.replace(/\%/ig, '');
							props.STAGE({
								_id: propertyID
								, mortgageLoan: +valueInt
							})
						}}
					/>
					<ValidTextField
						value={props.property.mortgageInterest}
						key={'props.property.mortgageInterest+props.property.mortgageInterest'}
						symbol="%"
						style={{
							width: "100%",
							marginBottom: "-15px",
							float: "left"
						}}
						floatingLabelText = "Interest"
						onBlur={(value) =>{
							let valueInt = value.replace(/\,/ig, '');
							valueInt = valueInt.replace(/\$/ig, '');
							valueInt = valueInt.replace(/\%/ig, '');
							props.STAGE({
								_id: propertyID
								, mortgageInterest: +valueInt
							})
						}}
					/>
					<div
					>
						<div style={{margin: "20px 0 0 0", display:"inline-block", width: "48%"}}>
		                    <p style={{marginTop: "10px", marginBottom: "-12px", userSelect: "none", color: "rgba(0, 0, 0, 0.298039)", fontWeight: "100", fontSize: "10px"}} >
		                    	First payment
							</p>
		                    <DatePicker
		                        style={{
		                            color: "#000"
		                        }}
		                        textFieldStyle={{
		                            fontSize: "16px"
		                            , height: "36px"
		                            , color: "#000"
		                        }}
		                        underlineStyle={{
		                            borderBottom: "0px solid"
		                        }}
		                        inputStyle={{color: "#000"}}
		                        underlineDisabledStyle={{borderBottom: "0px solid"}}
		                        hintText="Select"
								formatDate= {(date) => moment(date).format('YYYY-MM-DD')}
		                        hintStyle={{top: "8px"}}
		                        style={{width: "48%", height: "35px", marginTop: "8px"}}
								formatDate= {(date)=>getTimezoneDate(date).getDate().toString() + ' ' + getMonth(getTimezoneDate(date).getMonth()).toString() + ' ' + getTimezoneDate(date).getFullYear().toString()}
		                        value={(props.property.mortgageStart)?getTimezoneDate(props.property.mortgageStart):""}
		                        onChange={(evt, value)=>
		                            props.STAGE({
		                                _id: propertyID
		                              , mortgageStart: moment(value).format('YYYY-MM-DD')
		                            })
		                        }
		                    />
		                </div>
						<div style={{margin: "20px 0 0 0", display:"inline-block", width: "48%", float: "right"}}>
		                    <p style={{marginTop: "10px", marginBottom: "-12px", userSelect: "none", color: "rgba(0, 0, 0, 0.298039)", fontWeight: "100", fontSize: "10px"}} >
		                    	Last payment
							</p>
		                    <DatePicker
		                        textFieldStyle={{
		                            fontSize: "16px"
		                            , height: "36px"
		                            , color: "#000"
		                        }}
		                        underlineStyle={{
		                            borderBottom: "0px solid"
		                        }}
		                        inputStyle={{color: "#000"}}
		                        underlineDisabledStyle={{borderBottom: "0px solid"}}
		                        hintText="Select"
								formatDate= {(date) => moment(date).format('YYYY-MM-DD')}
		                        hintStyle={{top: "8px"}}
		                        style={{width: "48%", height: "35px", marginTop: "8px"}}
								formatDate= {(date)=>getTimezoneDate(date).getDate().toString() + ' ' + getMonth(getTimezoneDate(date).getMonth()).toString() + ' ' + getTimezoneDate(date).getFullYear().toString()}
		                        value={(props.property.mortgageEnd)?getTimezoneDate(props.property.mortgageEnd):""}
		                        onChange={(evt, value)=>
		                            props.STAGE({
		                                _id: propertyID
		                              , mortgageEnd: moment(value).format('YYYY-MM-DD')
		                            })
		                        }
		                    />
		                </div>

					</div>
					<div style={{display: "inline-block", width: "100%", marginBottom: "20px"}}>
						<ValidTextField
							value={props.loan.monthlyPayment}
							key={'props.property.monthlyPayment'+props.loan.monthlyPayment}
							symbol="$"
							style={{
								width: "48%",
								marginBottom: "-15px",
								float: "right"
							}}
							floatingLabelText = "Monthly Payment"
							disabled={true}
						/>
						<ValidTextField
							value={props.loan.principalLeft}
							key={'props.property.principalLeft'+props.loan.principalLeft}
							symbol="$"
							style={{
								width: "48%",
								marginBottom: "-15px",
								float: "left"
							}}
							floatingLabelText = "Loan principal left"
							disabled={true}
						/>
					</div>
				</div>
			</Section>
		)
	}
}

export default connect(select, dataActions)(Schedules)



// WEBPACK FOOTER //
// ./src/routes/landlord/propertyForm/Schedule.js